// 会议室预约管理系统
<template>
  <div class="MRMS" @click="dblBtn">
    <div class="leftArea">
      <div class="title">
        <img class="logo" src="../../../static/MRMS/images/logo.png" alt="">
        <p class="text">广州极酷物联智能科技有限公司</p>
      </div>
      <div class="partone">
        <div class="current">
          <p class="time pl25">8:00 <span class="sx">AM</span></p>
          <p class="date pl25">2019-10-11 <span class="week">星期三</span></p>
          <img class="meetingImg" src="../../../static/MRMS/images/meeting.png" alt="">
        </div>
        <div class="content">
          <p class="status" :class="'status'+status">{{status == 1 ? '空闲中' : status == 2 ? '使用中' : '现可用'}}</p>
          <p class="mid">
            <span class="roomName">小会议室</span>
            <span class="timeRange" v-if="status == 1">9:00开始下个使用预约</span>
            <span class="timeRange" v-else>预约时间: 09:00~11:30</span>
          </p>
          <div class="detail" v-if="status == 1">
            <p class="noText">当前无人使用,可扫描右边小程序码进行预约</p>
          </div>
          <div class="detail" v-else>
            <div class="li tit">
              <p class="name">预约人</p>
              <p class="tit">会议标题</p>
              <p class="num">参会人数</p>
            </div>
            <div class="li">
              <p class="name">张三</p>
              <p class="tit">销售会议</p>
              <p class="num">3人</p>
            </div>
          </div>
        </div>
      </div>
      <p class="partTitle">预约情况</p>
      <div class="parttwo">
        <div class="left"></div>
        <div class="right">
          <p class="text1">无需经过<br/>管理员审核</p>
          <p class="text2">提交预约后<span class="bold">登录小程序</span><br/>立即使用会议室</p>
          <p class="btn-use" @click="dialogVisible = true">立即使用</p>
        </div>
      </div>
    </div>
    <div class="rightArea">
      <div class="QRcode">
        <img class="img" src="../../../static/MRMS/images/code.png" alt="">
        <p class="text">会议室预约二维码</p>
      </div>
      <p class="listTit">即将开始的会议</p>
      <el-scrollbar class="list-wrapper">
        <div class="list" v-for="(item, index) in 10" :key="index">
          <p class="time">9:00~12:00</p>
          <p class="info">
            <span class="fq">张三</span>
            <span class="tit">销售会议</span>
          </p>
          <p class="num">3人参会</p>
        </div>
      </el-scrollbar>
    </div>

    <!-- 立即使用弹窗 -->
    <el-dialog width="5.9rem" :visible.sync="dialogVisible">
      <el-form class="form" ref="form" :model="form" label-width="80px">
        <!-- <el-input v-model="form.phone" placeholder="请输入电话号码"></el-input>
        <el-input v-model="form.title" placeholder="请输入会议标题"></el-input> -->
        <div class="item">
          <input class="input" type="number" pattern="[0-9]*" v-model="form.phone" placeholder="请输入电话号码" oninput="this.value=this.value.replace(/[^0-9.]+/,'');if(value.length>11)value=value.slice(0,11)" />
        </div>
        <div class="item">
          <input class="input" type="text" v-model="form.title" placeholder="请输入会议标题">
        </div>
        <div class="item fs28 timeSelector">
          <i class="el-icon-time"></i>
          <span class="start_time lt">{{form.start_time}}</span>
          <span class="zhi">至</span>
          <div class="end_time" :class="{'lt':form.end_time != ''}">
            <span @click="timeVisible = true">{{form.end_time == '' ? '选择时间' : form.end_time}}</span>
            <van-datetime-picker
              type="time"
              class="timePicker"
              v-model="pickerTime"
              :item-height=65
              v-if="timeVisible"
              @cancel="timeVisible = false"
              @confirm="getEndTime"
            />
          </div>
        </div>
        <div class="item fs28 address">
          <i class="el-icon-location-outline"></i>
          <span class="address">小会议室</span>
        </div>
        <div class="item">
          <el-button class="btn-confirm" type="primary" @click="onSubmit">确定使用</el-button>
        </div>
      </el-form>
      <p class="errorText">当前无法预约！预约人非本公司员工</p>
    </el-dialog>
    
    <div class="configBtn" v-show="showBtn == true" @click.stop><el-button type="info" @click="toConfig">修改配置</el-button></div>
    <!-- <custService></custService> -->
  </div>
</template>

<script>
  import custService from '../../assets/custService'
  let vm

  export default {
  name: 'MRMS',
  components:{
    custService
  },
  data () {
    return {
      // 1空闲中,2使用中,3现可用
      status: '3',
      dialogVisible: false,
      timeVisible: false,
      pickerTime: '12:01',
      form: {
        phone: '',
        title: '',
        start_time: '12:01',
        end_time: ''
      },


      showBtn:false,
      num:0,//点击次数
    }
  },
  created () {
    vm = this
  },
  mounted () {
    console.log(document.body.clientWidth + '：'+ document.body.clientHeight)
  },
  methods: {
    // 确认使用
    onSubmit() {
      console.log('submit!');
      vm.dialogVisible = false
    },
    // 获取结束时间
    getEndTime (val) {
      console.log('val', val)
      vm.form.end_time = val
      vm.timeVisible = false
    },

    //连续点击屏幕5次
    dblBtn(){
      var that = this;
      this.num++
      if(this.num==1){
        that.timer1=new Date().getTime()/1000
      }
      if(this.num==5){
        this.timer4= new Date().getTime()/1000
        if(that.timer4-that.timer1<=2){
          that.num=0
          that.showBtn=true
          setTimeout(function(){
            that.showBtn = false
          },5000);
        }else {
          this.num=0
        }
        console.log('tag', '')
      }
    },
    //跳转到配置页
    toConfig(){
      this.$router.push({
        path:'/CConfigSetting',
        query:{
          'project':true,
        }
      })
    },
  }
}
</script>

<style lang="less">
  .configBtn{
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .MRMS {
    width: 100%;
    height: 100vh;
    color: #333333;
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    .leftArea {
      width: 14.1rem;
      height: 100vh;
      background-image: linear-gradient(to right, #e9f1f9, #e4edf8,#cad9f0, #aec4e6, #9eb7df);
      padding: 0 0.4rem;
      .title {
        width: 100%;
        margin: 0.54rem 0 0.2rem 0.2rem;
        display: flex;
        align-items: center;
        .logo {
          width: 0.51rem;
          height: 0.44rem;
          margin-right: 0.05rem;
        }
        .text {
          font-size: 0.36rem;
          line-height: 0.44rem;
          font-weight: bold;
          color: #333333;
        }
      }
      .partone {
        width: 100%;
        height: 4.07rem;
        padding: 0.37rem 1.55rem 0.3rem 0;
        // padding: 0.37rem 1.55rem 0.3rem 0.35rem;
        border-radius: 0.2rem;
        background-color: #ffffff;
        display: flex;
        justify-content: space-between;
        .current {
          padding-left: 0.35rem;
          flex-shrink: 0;
          .pl25{
            padding-left: 0.25rem;
          }
          .time {
            width: 100%;
            margin-bottom: 0.25rem;
            font-weight: bold;
            font-size: 0.72rem;
            line-height: 1;
            position: relative;
            .sx{
              font-size: 0.38rem;
              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
          .date {
            font-size: 0.33rem;
            color: #666666;
            margin-bottom: 0.3rem;
          }
          .meetingImg {
            width: 2.86rem;
            height: 1.84rem;
          }
        }
        .content {
          width: 5.4rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .status {
            width: 1.64rem;
            height: 1.64rem;
            font-size: 0.4rem;
            font-weight: bold;
            border-radius: 50%;
            text-align: center;
            line-height: 1.64rem;
            color: #ffffff;
          }
          // 空闲中
          .status.status1 {
            background-color: #8ccf5d;
          }
          // 使用中
          .status.status2 {
            background-color: #ff9453;
          }
          // 现可用
          .status.status3 {
            background-color: #00acbe;
          }
          .mid {
            width: 100%;
            font-size: 0.34rem;
            line-height: 0.46rem;
            margin: 0.4rem 0 0.1rem;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            .roomName{
              flex-shrink: 0;
              font-size: 0.32rem;
              // margin-right: 0.5rem;
              color: #4740da;
            }
            .timeRange{
              flex-shrink: 0;
            }
          }
          .detail {
            width: 100%;
            .noText {
              font-size: 0.26rem;
              line-height: 0.46rem;
              color: #666666;
            }
            .li.tit {
              font-size: 0.22rem;
              line-height: 0.36rem;
              font-weight: normal;
              color: #999999;
            }
            .li {
              font-size: 0.26rem;
              line-height: 0.46rem;
              font-weight: bold;
              color: #666666;
              display: flex;
              p {
                flex-shrink: 0;
              }
              p.name {
                width: 32%;
              }
              p.tit {
                width: 48%;
              }
              p.num {
                width: 20%;
              }
            }
          }
        }
      }
      .partTitle {
        font-size: 0.32rem;
        font-weight: bold;
        line-height: 0.52rem;
        margin: 0.36rem 0 0.1rem;
        padding-left: 0.15rem;
      }
      .parttwo {
        width: 100%;
        height: 4.1rem;
        display: flex;
        .left {
          flex-shrink: 0;
          width: 10.7rem;
          background-color: #ffffff;
          border-top-left-radius: 0.2rem;
          border-bottom-left-radius: 0.2rem;
        }
        .right {
          flex-shrink: 0;
          width: 2.6rem;
          padding: 0.85rem 0.2rem 0.2rem;
          text-align: center;
          background-color: #e8edfb;
          border-top-right-radius: 0.2rem;
          border-bottom-right-radius: 0.2rem;
          .text1 {
            font-weight: bold;
            font-size: 0.24rem;
            line-height: 0.36rem;
          }
          .text2 {
            font-size: 0.22rem;
            line-height: 0.36rem;
            color: #666666;
            margin: 0.25rem 0 0.7rem;
            .bold {
              font-weight: bold;
            }
          }
          .btn-use {
            width: 100%;
            height: 0.67rem;
            line-height: 0.67rem;
            color: #ffffff;
            background-color: #736def;
            border-radius: 0.05rem;
            box-shadow: 0.03rem 0.03rem 0.03rem rgba(0, 0, 0, 0.1), -0.03rem 0.03rem 0.03rem rgba(0, 0, 0, 0.1), 0.03rem -0.03rem 0.03rem rgba(0, 0, 0, 0.1), -0.03rem -0.03rem 0.03rem rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
    .rightArea {
      width: 5.1rem;
      height: 100vh;
      padding: 1.18rem 0.5rem 0;
      background-color: #736def;
      display: flex;
      flex-direction: column;
      .QRcode {
        width: 100%;
        height: 4.07rem;
        flex-shrink: 0;
        padding: 0.3rem 0.5rem 0;
        background-color: #ffffff;
        border-radius: 0.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .img {
          width: 2.85rem;
          height: 2.85rem;
        }
        .text {
          font-size: 0.28rem;
          line-height: 0.3rem;
          font-weight: bold;
          margin-top: 0.25rem;
        }
      }
      .listTit {
        flex-shrink: 0;
        height: 0.36rem;
        margin: 0.46rem 0 0.16rem;
        color: #ffffff;
        padding-left: 0.47rem;
        font-size: 0.32rem;
        line-height: 0.36rem;
        background: url('../../../static/MRMS/images/shijian.png') left center no-repeat;
        background-size: 0.36rem;
      }
      .list-wrapper {
        width: 100%;
        height: 100%;
        .list {
          width: 100%;
          padding:  0.14rem 0.1rem 0.2rem 0.37rem;
          margin-bottom: 0.3rem;
          border-radius: 0.1rem;
          background-color: #ffffff;
          line-height: 0.32rem;
          position: relative;
          .time {
            font-size: 0.26rem;
            color: #666666;
          }
          .info {
            font-size: 0.32rem;
            font-weight: bold;
            color: #666666;
            margin: 0.2rem 0 0.1rem;
            .fq {
              color: #7254f1;
            }
          }
          .num {
            font-size: 0.22rem;
            font-weight: bold;
            color: #999999;
          }
        }
        .list::after {
          content: '';
          width: 0.1rem;
          height: 100%;
          border-top-left-radius: 0.1rem;
          border-bottom-left-radius: 0.1rem;
          position: absolute;
          left: 0;
          top: 0;
        }
        .list:nth-child(3n+1)::after  {
          background-color: #ff9453;
        }
        .list:nth-child(3n+2)::after  {
          background-color: #ffd24f;
        }
        .list:nth-child(3n)::after  {
          background-color: #2bc8d8;
        }
      }
    }
    .el-dialog {
      background-color: #ffffff;
      position: relative;
      .el-dialog__header {
        background-color: #ffffff;
        padding: 20px 20px 0;
      }
      .el-dialog__header > .el-dialog__headerbtn {
        font-size: 0.5rem;
        top: 50%;
      }
      .el-dialog__close {
        color: #999999!important;
      }
      .el-dialog__body{
        padding: 0.3rem 0.45rem 0.7rem;
      }
      .form {
        .item {
          .input {
            width: 100%;
            color: #a8acb4;
            padding-left: 0.1rem;
            margin-top: 0.46rem;
            font-size: 0.24rem; 
            line-height: 0.42rem;
            border-bottom: 1px solid #736def;
          }
          .input::placeholder {
            color: #a8acb4;
          }
          .btn-confirm {
            padding: 0;
            width: 100%;
            height: 0.8rem;
            line-height: 0.8rem;
            font-size: 0.32rem;
            font-weight: bold;
            background-color: #5f65e2;
            border: none;
          }
        }
        .item.fs28 {
          font-size: 0.28rem;
          line-height: 0.36rem;
          display: flex;
          align-items: center;
          i {
            color: #666666;
            margin-right: 0.1rem;
          }
        }
        .item.timeSelector {
          margin-top: 0.48rem;
          i{
            font-size: 0.24rem;
          }
          .zhi {
            margin: 0 0.18rem;
          }
          .lt {
            letter-spacing: 0.03rem;
          }
          .end_time {
            width: 5em;
            color: #736def;
            position: relative;
            .timePicker {
              width: 200%;
              box-shadow: 0.01rem 0.01rem 0.01rem rgba(0, 0, 0, 0.1), -0.01rem 0.01rem 0.01rem rgba(0, 0, 0, 0.1), 0.01rem -0.01rem 0.01rem rgba(0, 0, 0, 0.1);
              position: absolute;
              top: 101%;
              left: 0;
              z-index: 10;
              // 确认取消
              .van-picker__toolbar {
                height: 0.7rem;
                line-height: 0.7rem;
                .van-picker__cancel,
                .van-picker__confirm {
                  font-size: 0.24rem;
                  padding: 0 0.15rem;
                }
              }
              .van-picker-column {
                font-size: 0.24rem;
              }
            }
          }
        }
        .item.address {
          margin: 0.2rem 0 0.9rem;
          i {
            font-size: 0.26rem;
          }
        }
      }
      .errorText {
        width: 100%;
        text-align: center;
        font-size: 0.22rem;
        line-height: 0.3rem;
        color: #f34f4f;
        position: absolute;
        bottom: 1.6rem;
        left: 0;
      }
    }
    
  }
</style>


// WEBPACK FOOTER //
// src/components/MRMS/MRMS.vue